import { InstallmentPaymentMethod } from '../types/InstallmentPaymentMethod';
import { DeviceType } from '../types/DeviceType';
import { DesktopModalSize, MobileModalSize } from '../common.constants';

export const getModalSize = (deviceType, paymentMethod, sizeFromServer) =>
  // Gets modal size depends on payment method, gracefully falling back to the default size (which is Afterpay)
  deviceType === DeviceType.Mobile
    ? MobileModalSize
    : sizeFromServer || DesktopModalSize?.[paymentMethod] || DesktopModalSize[InstallmentPaymentMethod.Afterpay];
